module.exports = __webpack_public_path__ + "img/givevvv.a9193619.svg";